import {Injectable} from '@angular/core';
import {CurrentSkedTask} from '../model/task';
import * as moment from 'moment-timezone';
import {TimezoneService} from '../../services/timezone.service';

@Injectable({
  providedIn: 'root',
})
export class SkedTaskProcessorService {
  constructor(private timezoneService: TimezoneService) {}

  processSkedTasks(primaryTasks: CurrentSkedTask[] = [], teamTasks: CurrentSkedTask[] = []): CurrentSkedTask[] {
    // Keep track of task IDs from the primary sked
    const seenIds = new Set<string>();

    // First, add all tasks from the primary sked (preserving their order)
    const combinedTasks = [...primaryTasks];

    // Track all IDs from the primary sked
    combinedTasks.forEach(task => seenIds.add(task._id));

    // Then add tasks from teamSked only if they don't already exist
    teamTasks.forEach(teamTask => {
      if (!seenIds.has(teamTask._id)) {
        combinedTasks.push(teamTask);
        seenIds.add(teamTask._id);
      }
    });

    // Filter out tasks that haven't started yet
    const now = moment().tz(this.timezoneService.getTimeZone());
    const filteredTasks = combinedTasks.filter(task => {
      const startTime = moment(task.startDateTime).tz(this.timezoneService.getTimeZone());
      return startTime.isSameOrBefore(now);
    });

    // Sort tasks by adjustedPriority (higher values first)
    return filteredTasks.sort((a, b) => (b.adjustedPriority ?? 0) - (a.adjustedPriority ?? 0));
  }
}
